import React from "react";
import { FaEnvelope, FaPhone, FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import frontImg from "../img/schronisko_front.webp";
import "./MainPage.css";

function MainPage() {
  return (
    <div className="main-page">
      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-left">
          <FaEnvelope className="icon" />
          <span>schronisko.bartne@gmail.com</span>
        </div>
        <div className="navbar-right">
          <FaPhone className="icon" />
          <span>+48 18 351 80 32</span>
        </div>
      </nav>

      {/* Main Image */}
      <div className="main-image">
        <img src={frontImg} alt="Schronisko Bartne" />

        {/* Text on the image */}
        <div className="hero-text">
          <h1>SCHRONISKO PTTK - 655 m n.p.m.</h1>
          <h2>Bartne</h2>
          <p>
            "Schronisko w Bartnym to drewniana chata położona w lesie, gdzie wciąż jeszcze
            słychać skrzypienie drewnianych podłóg. To miejsce gdzie kończy się cywilizacja
            a zaczyna spokój gór i lasów. Zapraszamy do Krainy Łagodności"
          </p>
        </div>
      </div>




      {/* Footer */}
      <footer className="footer">
        <h2>BACÓWKA BARTNE</h2>
        <p>
          Ewa Biel<br />
          <strong>KONTAKT</strong><br />
          Telefon: +48 18 351 80 32<br />
          E-mail: schronisko.bartne@gmail.com
        </p>
        <div className="social-icons">
          <FaFacebook />
          <FaInstagram />
          <FaWhatsapp />
        </div>
      </footer>
    </div>
  );
}

export default MainPage;
